<input-container [labelPosition]="labelPosition" [labelClass]="labelClass" [controlName]="controlName" [required]="required" [control]="control" [loading]="loading" [disabled]="disabled" [label]="label" [labelInfo]="labelInfo" [icon]="icon" [bold]="bold">
    <div class="dropdown d-grid">
        <button class="btn btn-outline-secondary text-end" #inputElement [class.dropdown-toggle]="!isDisabled" [class.disabled]="isDisabled" type="button" [attr.id]="generatedId(controlName) + '_timer_dropdown'" data-bs-toggle="dropdown" aria-expanded="false">
            {{getButtonText()}}
        </button>
        <div class="dropdown-menu timer-dropdown" [attr.aria-labelledby]="generatedId(controlName) + '_timer_dropdown'">
            <form class="px-4 py-3" [formGroup]="formDropdown">
                <div *ngIf="!isOnlyHours" class="mb-3">
                    <label [attr.for]="generatedId(controlName) + '_group'">
                        Dias úteis
                        <i class="bi bi-info-circle label-info" data-bs-toggle="tooltip" data-bs-placement="top" title="{{hoursPerDay}} horas diárias"></i>
                    </label>
                    <div class="input-group mb-3" [id]="generatedId(controlName) + '_group'">
                        <input type="number" class="form-control" formControlName="days" step="1">
                        <span class="input-group-text">{{getDaysInHours()}}</span>
                    </div>
                </div>
                <div *ngIf="!isOnlyDays" class="mb-3">
                    <label [attr.for]="generatedId(controlName) + '_group_timer'">Horas e Minutos</label>
                    <div class="input-group col-6 mb-3" [id]="generatedId(controlName) + '_group_timer'">
                        <input type="number" class="form-control" formControlName="hours" step="1">
                        <span class="input-group-text">:</span>
                        <input type="number" class="form-control" formControlName="minutes" step="1">
                    </div>
                </div>
                <div *ngIf="!isOnlyHours && !isOnlyDays" class="mb-3">
                    <label for="horas" class="form-label">Horas</label>
                    <input type="range" class="form-range" min="0" [attr.max]="hoursPerDay" id="horas" formControlName="hours">
                </div>
                <div *ngIf="!isOnlyDays" class="mb-3">
                    <label for="minutos" class="form-label">Minutos</label>
                    <input type="range" class="form-range" min="0" max="59" id="minutos" formControlName="minutes">
                </div>
            </form>
        </div>
    </div>
</input-container>